import type { TFunction } from "i18next";

/** Localized display name for a payment region code (`IT`, `ES`, …). */
export function regionDisplayName(
  code: string,
  t: TFunction<"common">,
  fallback?: string,
): string {
  return t(`region.names.${code}`, {
    defaultValue: fallback?.trim() || code,
  });
}
